module.exports = __webpack_public_path__ + "static/img/network_en.862e3ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/network_en.jpg
// module id = HOEl
// module chunks = 3